// extracted by mini-css-extract-plugin
module.exports = {"how-to":"HowTo_how-to__S2MJ7","how-to-title":"HowTo_how-to-title__eWI78","how-to-content":"HowTo_how-to-content__hd49q"};